import PublicHashSealMask from "./assets/hash-public.webp"

export const PublicHash = ({ publicHash }: { publicHash: string }) => {
	return (
		<div className="relative mb-2 w-[270px]">
			<img src={PublicHashSealMask || "/placeholder.svg"} alt="Código público do selo" />
			<div className="w-full max-w-[150px] h-[30px] flex justify-center absolute top-[17px] left-[60px] rounded-md bg-black/70">
				<p className="text-[25px] -mt-[4px] font-[Doto] font-bold text-center text-white">{publicHash}</p>
			</div>
		</div>
	)
}
